<template>
    <div class="select-col">
        <div id="shibl" v-bind:class="[ 'filter-reset-btn', 'fabric-switch', (activeType === 'shibl' ? 'basic-bg' : '') ]"
             @click="loadFabrics">{{ translations['Shirt & blouse fabrics'] }}
        </div>
        <div id="suit" v-bind:class="[ 'filter-reset-btn', 'fabric-switch', (activeType === 'suit' ? 'basic-bg' : '') ]"
             @click="loadFabrics">{{ translations['Suit fabrics'] }}
        </div>
        <div class="designer-detailbox-description">
        </div>
        <!-- FILTERBOXES -->
        <filter v-if="activeType === 'shibl'" :filtercolor="filtercolor" :filterpattern="filterpattern" :filterweave="filterweave"
                :filtermaterial="filtermaterial"
                :filteroccasion="filteroccasion" :range1="range1" :range2="range2" :boolfilter="boolfilter"
                :filtername="filtername"></filter>
        <filtersuit v-if="activeType === 'suit'" :filtercolor="filtercolor" :filterpattern="filterpattern" :filterweave="filterweave"
                :filtermaterial="filtermaterial"
                :filteroccasion="filteroccasion" :range1="range1" :range2="range2" :boolfilter="boolfilter"
                :filtername="filtername"></filtersuit>
        <!-- FABRICS -->
        <fabrics :baseurl="baseurl" :box="box" :fabrics="fabrics" :filtercolor="filtercolor"
                 :filterpattern="filterpattern" :filterweave="filterweave" :filtermaterial="filtermaterial"
                 :filteroccasion="filteroccasion" :range1="range1"
                 :range2="range2" :boolfilter="boolfilter" :fields="fields" :filtername="filtername"
                 :personal="personal" :muster1="muster1" :muster2="muster2" :muster3="muster3"
                 :muster4="muster4" :showpattern="showPattern" :showcolor="showColor" :showweave="showWeave"
                 :showmaterial="showMaterial" :showoccasion="showOccasion" :showprice="showPrice"
                 :showname="showName" :isactive="isactive" :currentData="currentData"></fabrics>
    </div>
</template>

<script>
var jQuery = require('jquery')

import Filter from '../partials/Filter.vue'
import Filtersuit from '../partials/Filtersuit.vue'
import Fabrics from '../partials/Fabrics.vue'

export default {
  name: 'Fabric',
  data: function () {
    return {
      showPattern: false,
      showColor: false,
      showWeave: false,
      showMaterial: false,
      showOccasion: false,
      showPrice: false,
      showSeason: false,
      filtercolor: '',
      filterpattern: '',
      filterweave: '',
      filtermaterial: '',
      filteroccasion: '',
      filtername: '',
      activeType: 'shibl',
      fields: [ 'name', 'color', 'weave', 'season', 'occasion', 'pattern', 'material' ],
      boolfilter: { 'topseller': '0', 'new': '0' },
      range1: { value: 49, min: 49, max: 99 },
      range2: { value: 99, min: 50, max: 99 },
      globals: window.stoffmuster,
      translations: window.stoffmuster.translations,
      scrolling: false
    }
  },
  components: {
    Filter,
    Filtersuit,
    Fabrics
  },
  props: {
    'baseurl': String,
    'personal': Object,
    'fabrics': Array,
    'zoom': Object,
    'filtercolor': String,
    'filterpattern': String,
    'filterweave': String,
    'filtermaterial': String,
    'filteroccasion': String,
    'filtername': String,
    'muster1': String,
    'muster2': String,
    'muster3': String,
    'muster4': String,
    'isactive': Array,
    'currentData': Object,
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  },
  events: {
    setFilter: function (event, callback) {
      switch (event.currentTarget.dataset.select) {
        case 'color':
          if (event.currentTarget.id === 'all') {
            this.filtercolor = ''
            this.showColor = false
            callback('Color')
          } else {
            this.filtercolor = event.currentTarget.id
            callback(this.filtercolor)
          }
          break
        case 'pattern':
          if (event.currentTarget.id === 'all') {
            this.filterpattern = ''
            this.showPattern = false
            callback('Pattern')
          } else {
            this.filterpattern = event.currentTarget.id
            callback(this.filterpattern)
          }
          break
        case 'weave':
          if (event.currentTarget.id === 'all') {
            this.filterweave = ''
            this.showWeave = false
            callback('Weave')
          } else {
            this.filterweave = event.currentTarget.id
            callback(this.filterweave)
          }
          break
        case 'material':
          if (event.currentTarget.id === 'all') {
            this.filtermaterial = ''
            this.showMaterial = false
            callback('Material')
          } else {
            this.filtermaterial = event.currentTarget.id
            callback(this.filtermaterial)
          }
          break
        case 'occasion':
          if (event.currentTarget.id === 'all') {
            this.filteroccasion = ''
            this.showOccasion = false
            callback('Occasion')
          } else {
            this.filteroccasion = event.currentTarget.id
            callback(this.filteroccasion)
          }
          break
        case 'name':
          this.filtername = event.currentTarget.value
          callback(this.filtername)
          break
      }
    },
    checkDesign: function (event) {
      this.$dispatch('mainCheckDesign', event, function () {})
    },
    setBoolFilter: function (event, callback) {
      if (this.boolfilter[event.currentTarget.id] !== '1') {
        this.boolfilter[event.currentTarget.id] = '1'
        callback('1')
      } else {
        this.boolfilter[event.currentTarget.id] = '0'
        callback('0')
      }
    },
    resetFilter: function () {
      this.resetFilter()
    }
  },
  methods: {
    selectFabric: function (event) {
      this.$dispatch('getFabricData', event)
    },
    showFilter: function (event) {
      this.resetFilter()
      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'))
      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1)
      this[f] = 'true'
    },
    thumbUrl: function (event) {
      return this.baseurl + event.currentTarget.dataset.thumb
    },
    resetBoolFilter: function () {
      var b
      for (b in this.boolfilter) {
        this.boolfilter[b] = '0'
      }
    },
    setCurrentData: function (sku) {
      this.currentData = jQuery.grep(this.fabrics, function (e) { return e.ref_number === sku })[0]
    },
    loadFabrics: function (event) {
      if (event.currentTarget.id === 'suit') {
        this.range1 = { value: 299, min: 299, max: 700 }
        this.range2 = { value: 700, min: 300, max: 700 }
      } else if (event.currentTarget.id === 'shibl') {
        this.range1 = { value: 49, min: 49, max: 100 }
        this.range2 = { value: 100, min: 50, max: 100 }
      } else {
        this.range1 = { value: 0, min: 0, max: 100 }
        this.range2 = { value: 100, min: 0, max: 100 }
      }
      jQuery.getJSON(this.baseurl + 'designer/ajax/getFabricList', { type: event.currentTarget.id, swatch: 1 }, function (data) {
        this.fabrics = data
      }.bind(this))
      this.activeType = event.currentTarget.id
      this.resetFilter()
    },
    resetFilter: function () {
      this.showPattern = false
      this.showColor = false
      this.showWeave = false
      this.showMaterial = false
      this.showOccasion = false
      this.showSeason = false
      this.showPrice = false
      this.showName = false
      this.range1.value = this.range1.min
      this.range2.value = this.range2.max
      this.resetBoolFilter()
      this.filtercolor = ''
      this.filterpattern = ''
      this.filterweave = ''
      this.filtermaterial = ''
      this.filteroccasion = ''
      this.filtername = ''
    }
  },
  created: function () {
    jQuery.getJSON(this.baseurl + 'designer/ajax/getFabricList', { type: 'shibl', swatch: 1 }, function (data) {
      this.fabrics = data
    }.bind(this))
    this.box = { 'component': 'fabric', 'title': 'Stoff', 'todo': 'Wählen Sie aus diesen Stoffen.' }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>





// WEBPACK FOOTER //
// Fabric.vue?b8f70bac